import { useSelectField } from '@zurich/common/hooks';
import { Select } from '@zurich/ui/legacy/components';
import type { AutoArea } from '~/lib/types';
import {
  damagedTypeValidationSelectorFamily,
  typeOfDamageFieldSelectorFamily,
} from '~/state';

const damageTypeOptions = (vehicleType: AutoArea) => [
  ...(vehicleType !== 'windshield'
    ? [
        {
          label: 'Delle',
          value: 'Delle',
        },
        {
          label: 'Kratzer',
          value: 'Kratzer',
        },
      ]
    : []),
  {
    label: 'Sprung',
    value: 'Sprung',
  },
  {
    label: 'Steinschlag',
    value: 'Steinschlag',
  },
  {
    label: 'Sonstiges',
    value: 'Sonstiges',
  },
];

export function TypeOfDamageSelect({
  id,
  step,
}: {
  id: string;
  step: AutoArea;
}) {
  const typeOfDamageProps = useSelectField({
    atom: typeOfDamageFieldSelectorFamily({
      id,
    }),
    validationSelector: damagedTypeValidationSelectorFamily(id),
    fieldName: 'damageType',
    i18nPrefix: 'vsga:fields.',
    required: true,
  });

  return (
    <Select
      {...typeOfDamageProps}
      data-name="damage-type"
      options={damageTypeOptions(step)}
    />
  );
}
